export default [
  {
    altText: "Certified Super",
    bannerID: "Certified Super",
    buttonText: "",
    desktopImage:
      "https://www.airasia.com/aa/images/web-apps/certified-super/hero-banner-web2.jpg",
    headline: "",
    mobileImage:
      "https://www.airasia.com/aa/images/web-apps/certified-super/hero-banner-mobile.jpg",
    subheadline: "",
    tabletImage:
      "https://www.airasia.com/aa/images/web-apps/certified-super/hero-banner-web2.jpg",
  }
]
